import { render, staticRenderFns } from "./DetectiveLoading.vue?vue&type=template&id=2f5a5012&scoped=true&"
import script from "./DetectiveLoading.vue?vue&type=script&lang=js&"
export * from "./DetectiveLoading.vue?vue&type=script&lang=js&"
import style0 from "./DetectiveLoading.vue?vue&type=style&index=0&id=2f5a5012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a5012",
  null
  
)

export default component.exports